import { useLayoutEffect, useRef } from 'react';

/**
 * Returns a stable ref holding the value of the latest render, so an event
 * listener subscribed once can read current callbacks without resubscribing.
 */
export function useLatest<T>(value: T) {
  const ref = useRef(value);

  useLayoutEffect(() => {
    ref.current = value;
  });

  return ref;
}
